import { render, staticRenderFns } from "./RedteaGo-web.vue?vue&type=template&id=7aea934c&scoped=true"
import script from "./RedteaGo-web.vue?vue&type=script&lang=js"
export * from "./RedteaGo-web.vue?vue&type=script&lang=js"
import style0 from "./RedteaGo-web.vue?vue&type=style&index=0&id=7aea934c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aea934c",
  null
  
)

export default component.exports